import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import { HpRespPromoModulePromoItemOld } from './HpRespPromoModulePromoItemOld';
import { HpRespModuleContainerOld } from '../HpRespModuleContainerOld/HpRespModuleContainerOld';
import { trackPromoImpressions, trackPromoClick } from './helpers/PromoTrackingOld';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';

class HpRespPromoModulePrimaryOldComponent extends Component {
    handleInitialDisplay = ({ inViewport }) => {
        const { componentModule } = this.props;
        if (componentModule && inViewport) {
            const { items } = componentModule;
            trackPromoImpressions({ items, startingIndex: 0 });
        }
    };

    render() {
        const { componentModule, useLazyLoadImages } = this.props;
        if (!componentModule) {
            return null;
        }

        const { title, items } = componentModule;

        return (
            <HpRespModuleContainerOld addTopGap={!title}>
                <HpRespModuleContainerOld.Header>{title}</HpRespModuleContainerOld.Header>
                <SharedInViewport stopWhenInViewport onInViewportChange={this.handleInitialDisplay}>
                    <div className="rowFlex">
                        {items.map((promotion, index) => (
                            <HpRespPromoModulePromoItemOld
                                key={promotion.cmsId}
                                promotion={promotion}
                                useLazyLoadImages={useLazyLoadImages}
                                className={items.length === 1 ? 'colXs12' : 'colLg6 colXs12'}
                                isFullBleedImage={promotion.isFullBleedImage && items.length === 1}
                                onClick={() => trackPromoClick({ item: promotion, index })}
                            />
                        ))}
                    </div>
                </SharedInViewport>
            </HpRespModuleContainerOld>
        );
    }
}

HpRespPromoModulePrimaryOldComponent.propTypes = {
    componentModule: PropTypes.object,
    useLazyLoadImages: PropTypes.bool,
};

export const HpRespPromoModulePrimaryOld = createFragmentContainer(
    HpRespPromoModulePrimaryOldComponent,
    {
        componentModule: graphql`
            fragment HpRespPromoModulePrimaryOld_componentModule on PromoModule {
                title
                items {
                    cmsId
                    imageCopy
                    cta
                    ... on PromoItem @skip(if: $isMobile) {
                        imageUrl
                        imageHeight
                        imageWidth
                    }
                    ... on PromoItem @include(if: $isMobile) {
                        mobileImageUrl
                        mobileImageHeight
                        mobileImageWidth
                    }
                    linkData {
                        # path is used in PromoTrackingOld.js
                        path
                        ...SeoLink_linkData
                    }
                    isFullBleedImage
                }
            }
        `,
    }
);
